import React from "react";

import { Modal } from "antd";
import { Input, Form, Button, Divider, Select } from "antd";

import { CloudUploadOutlined, CloseOutlined } from "@ant-design/icons";

import * as Yup from "yup";

import {
    CONST_LANGUAGE_TYPE_NONE,
    CONST_LANGUAGE_TYPE_SINGLE,
    CONST_LANGUAGE_TYPE_PAIR,
} from "../../../config/consts/language";

const _filter = (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;

const defaultValues = {
    id: null,
    service: null,
    category: null,
    unit: null,
    language_family: "",
    language: null,
    language_pair: null,
    amount: "0",
};

class PriceModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultValues,
            categoryList: [],
            unitList: [],
            languageType: CONST_LANGUAGE_TYPE_NONE,
            errors: {
                id: null,
                service: null,
                category: null,
                unit: null,
                language_family: null,
                language: null,
                language_pair: null,
                amount: null,
            },
        };
    }

    componentDidMount() {
        if (this.props.price?.service !== undefined || this.props.price?.unit !== undefined) {
            const current = this.props.price?.service;
            const service = (this.props.services || []).find((item) => item.id === current);
            const units = (service?.units || []).map((item) => {
                return { value: item.id, label: item.name };
            });
            const categories = (service?.categories || []).map((item) => {
                return { value: item.id, label: item.name };
            });

            this.setState({
                ...this.props.price,
                languageType: service?.language,
                unitList: units,
                categoryList: categories,
            });
        }
    }

    changeServices = (current) => {
        const service = (this.props.services || []).find((item) => item.id === current);
        const units = (service?.units || []).map((item) => {
            return { value: item.id, label: item.name };
        });
        const categories = (service?.categories || []).map((item) => {
            return { value: item.id, label: item.name };
        });

        this.setState({
            service: current,
            languageType: service?.language,
            unitList: units,
            categoryList: categories,
            unit: null,
            language: null,
            language_pair: null,
        });
    };

    preSubmit = () => {
        let valid = true;
        let errors = false;

        if (!this.props.allowEmptyService && !this.state.service) {
            valid = false;
            errors = { ...this.state.errors, service: "Cannot be blank" };
        }

        if (!this.state.unit) {
            valid = false;
            errors = { ...errors, unit: "Cannot be blank" };
        }

        if (this.state.amount === null || this.state.amount === undefined || this.state.amount === "") {
            valid = false;
            errors = { ...errors, amount: "Cannot be blank" };
        } /*else if (!IsNumeric(this.state.amount)) {
            valid = false;
            errors = { ...errors, amount: 'Invalid price'}
        }*/

        if (!valid) {
            this.setState({ errors: errors });
            return;
        }

        const values = {
            id: this.state.id,
            service: this.state.service,
            unit: this.state.unit,
            category: this.state.category,
            language: this.state.language,
            language_family: this.state.language_family,
            language_pair: this.state.language_pair,
            amount: this.state.amount,
        };

        this.props.handleSubmit(values);
    };

    render() {
        const { modalVisible, onCancel, services, languages, languagePairs } = this.props;

        if (!modalVisible) {
            return null;
        }

        const isSubmitting = false;

        return (
            <Modal
                title="Price"
                onCancel={onCancel}
                visible={modalVisible}
                onOk={this.preSubmit}
                confirmLoading={isSubmitting}
                width={800}
                footer={[
                    <Button
                        key="back"
                        onClick={onCancel}
                        icon={
                            <>
                                <CloseOutlined />
                                <Divider type="vertical" />
                            </>
                        }
                    >
                        Cancel
                    </Button>,
                    <Button
                        key="submit"
                        loading={isSubmitting}
                        type="primary"
                        onClick={this.preSubmit}
                        icon={
                            <>
                                <CloudUploadOutlined />
                                <Divider type="vertical" />
                            </>
                        }
                    >
                        {isSubmitting ? "One moment ..." : "Save"}
                    </Button>,
                ]}
            >
                <Form.Item
                    label="Service"
                    validateStatus={this.state.errors.service ? "error" : false}
                    help={this.state.errors.service ? this.state.errors.service : false}
                    required={!this.props.allowEmptyService}
                >
                    <Select
                        style={{ width: "100%" }}
                        placeholder=""
                        options={services}
                        filterOption={_filter}
                        onChange={(val) => this.changeServices(val)}
                        value={this.state.service}
                        allowClear
                        showSearch
                    />
                </Form.Item>

                {(this.state.categoryList || []).length > 0 && (
                    <Form.Item label="Category">
                        <Select
                            style={{ width: "100%" }}
                            placeholder=""
                            options={this.state.categoryList}
                            filterOption={_filter}
                            onChange={(val) => this.setState({ category: val })}
                            value={this.state.category}
                            allowClear
                            showSearch
                        />
                    </Form.Item>
                )}

                <Form.Item
                    label="Unit"
                    required
                    validateStatus={this.state.errors.unit ? "error" : false}
                    help={this.state.errors.unit ? this.state.errors.unit : false}
                >
                    <Select
                        style={{ width: "100%" }}
                        placeholder=""
                        options={
                            this.state.service
                                ? this.state.unitList
                                : this.props.allowEmptyService
                                ? this.props.units
                                : this.state.unitList
                        }
                        filterOption={_filter}
                        onChange={(val) => this.setState({ unit: val })}
                        value={this.state.unit}
                        required
                        showSearch
                    />
                </Form.Item>

                {this.state.languageType === CONST_LANGUAGE_TYPE_SINGLE && (
                    <Form.Item label="Language Family">
                        <Select
                            placeholder="Language Family"
                            showSearch
                            onChange={(val) => this.setState({ language_family: val, language: null })}
                            value={this.state.language_family}
                            allowClear
                            showSearch
                        >
                            <Select.Option value="">None</Select.Option>
                            <Select.Option value="LTR">LTR</Select.Option>
                            <Select.Option value="RTL">RTL</Select.Option>
                        </Select>
                    </Form.Item>
                )}

                {this.state.languageType === CONST_LANGUAGE_TYPE_SINGLE && !this.state.language_family && (
                    <Form.Item label="Language">
                        <Select
                            style={{ width: "100%" }}
                            placeholder="All"
                            options={languages}
                            filterOption={_filter}
                            onChange={(val) => this.setState({ language: val })}
                            value={this.state.language}
                            allowClear
                            showSearch
                        />
                    </Form.Item>
                )}

                {this.state.languageType === CONST_LANGUAGE_TYPE_PAIR && (
                    <Form.Item label="Language Pair">
                        <Select
                            style={{ width: "100%" }}
                            placeholder="All"
                            options={languagePairs}
                            filterOption={_filter}
                            onChange={(val) => this.setState({ language_pair: val })}
                            value={this.state.language_pair}
                            allowClear
                            showSearch
                        />
                    </Form.Item>
                )}

                <Form.Item
                    label="Amount"
                    required
                    validateStatus={this.state.errors.amount ? "error" : false}
                    help={this.state.errors.amount ? this.state.errors.amount : false}
                >
                    <Input
                        style={{ width: "100%" }}
                        placeholder=""
                        onChange={(e) => this.setState({ amount: e.target.value })}
                        value={this.state.amount}
                        required
                    />
                </Form.Item>
            </Modal>
        );
    }
}

PriceModal.defaultProps = {
    modalVisible: false,
    prices: {},
    services: [],
    languages: [],
    languagePairs: [],

    handleSubmit: async () => {
        return;
    },
    onCancel: async () => {
        return;
    },
};

export default PriceModal;
